import React from 'react'

import PropTypes from 'prop-types'

import IconBase from '../IconBase/IconBase'

const ClaimServiceIcon = ({ fill = 'transparent', ...props }) => {
  return (
    <IconBase viewBox='0 0 18 18' {...props}>
      <g
        stroke='#3E4685'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        fill={fill}
        clipPath='url(#a)'
      >
        <path
          d='M15.623 6.804a1.49 1.49 0 1 1-2.108 2.108
         1.49 1.49 0 0 1 2.108-2.108M10.778 4.145A2.295 2.295
          0 1 1 7.532 7.39a2.295 2.295 0 0 1 3.246-3.246M4.787
           6.804a1.49 1.49 0 1 1-2.108 2.108 1.49 1.49 0 0 1
            2.108-2.108M17.26 13.786v-.807a1.842 1.842 0 0
             0-1.842-1.842h-.59M1.047 13.786v-.807c0-1.018.824-1.842
              1.842-1.842h.59M13.08 13.786v-1.18a2.58 2.58 0 0
               0-2.58-2.579H7.79a2.579 2.579 0 0 0-2.58 2.58v1.179'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h18v18H0z' />
        </clipPath>
      </defs>
    </IconBase>
  )
}

ClaimServiceIcon.propTypes = {
  fill: PropTypes.string,
}

export default ClaimServiceIcon
